import { atom } from "recoil";

export const loadingState = atom({
    key: 'isLoading', // unique ID (with respect to other atoms/selectors)
    default: false, // default value (aka initial value)
});

export const alertMessageState = atom({
    key: 'alertMessage', // unique ID (with respect to other atoms/selectors)
    default: "", // default value (aka initial value)
});